const selectors = {
  carousel: '[data-theme-carousel]',
  container: '[data-theme-carousel-container]',
  prev: '[data-theme-carousel-prev]',
  next: '[data-theme-carousel-next]',
};

export function setupCarousels() {
  document.querySelectorAll<HTMLElement>(selectors.carousel).forEach(setupCarousel);
}

function setupCarousel(carousel: HTMLElement) {
  const container = carousel.querySelector<HTMLElement>(selectors.container);
  if (!container) return;

  const prevButton = carousel.parentElement?.querySelector<HTMLButtonElement>(selectors.prev);
  const nextButton = carousel.parentElement?.querySelector<HTMLButtonElement>(selectors.next);

  const scrollAmount = () => carousel.offsetWidth;

  prevButton?.addEventListener('click', () => {
    container.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
  });

  nextButton?.addEventListener('click', () => {
    container.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
  });

  const updateButtonStates = () => {
    const isAtStart = container.scrollLeft <= 0;
    const isAtEnd = container.scrollLeft + container.clientWidth + 10 >= container.scrollWidth;

    prevButton?.toggleAttribute('disabled', isAtStart);
    nextButton?.toggleAttribute('disabled', isAtEnd);
  };

  container.addEventListener('scroll', updateButtonStates);
  updateButtonStates();

  new ResizeObserver(() => {
    const padding = carousel.offsetLeft;
    Object.assign(container.style, {
      paddingLeft: `${padding}px`,
      paddingRight: `${padding}px`,
      transform: `translateX(-${padding}px)`,
      scrollPaddingInlineStart: `${padding}px`,
    });

    if (prevButton) prevButton.style.left = `-${padding}px`;
    if (nextButton) nextButton.style.right = `-${padding}px`;

    updateButtonStates();
  }).observe(carousel);
}